var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3"},[_c('ImagesView',{attrs:{"change-permission":'change_inventoryitem',"inventory-uuid":_vm.inventory.uuid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }